module.exports = __webpack_public_path__ + "pc/img/main-work-img-01.f70b7997.png";